<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                {{ confirmMessage }}
              </strong>
            </v-row>

            <div class="my-3">
              <!-- クラウド設定 -->
              <v-row>
                <v-col>
                  <h3>クラウド設定</h3>
                </v-col>
              </v-row>
              <!--サービスキー(Act)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="サービスキー(Act)"
                    :value="cloudVnGcpDetail.cloudVnConnectAct.serviceKey"
                  />
                </v-col>
              </v-row>
              <!--サービスキー(Sby)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="サービスキー(Sby)"
                    :value="
                      cloudVnGcpDetail.cloudVnConnectSby
                        ? cloudVnGcpDetail.cloudVnConnectSby.serviceKey
                        : '-'
                    "
                  />
                </v-col>
              </v-row>
              <!--ロケーション-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ロケーション"
                    :value="
                      $filter.enumTo(
                        cloudVnGcpDetail.cloudVnConnectCommon.location,
                        'location'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--接続先仮想ネットワーク（VPN/VN）名-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="接続先仮想ネットワーク(VPN/VN)名"
                    :value="
                      cloudVnGcpDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                        'B'
                      )
                        ? cloudVnGcpDetail.cloudVnConnectCommon.vpnVnCode
                        : cloudVnGcpDetail.cloudVnConnectCommon.vnName +
                          ':' +
                          cloudVnGcpDetail.cloudVnConnectCommon.vpnVnCode +
                          '(L3)'
                    "
                  />
                </v-col>
              </v-row>

              <!-- VNコネクト設定 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>VNコネクト設定</h3>
                </v-col>
              </v-row>
              <!--品目-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="品目"
                    :value="
                      cloudVnGcpDetail.cloudVnConnectCommon.bandwidthType +
                      '(' +
                      $filter.bandwidthTo(
                        cloudVnGcpDetail.cloudVnConnectCommon.bandwidth
                      ) +
                      ')'
                    "
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Act)"
                    :value="cloudVnGcpDetail.cloudVnConnectAct.vnConnectName"
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Sby)"
                    :value="
                      cloudVnGcpDetail.cloudVnConnectSby
                        ? cloudVnGcpDetail.cloudVnConnectSby.vnConnectName
                        : '-'
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（共通） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(共通)</h3>
                </v-col>
              </v-row>
              <!--ルーティング種別-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ルーティング種別"
                    :value="cloudVnGcpDetail.cloudVnConnectCommon.routingType"
                  />
                </v-col>
              </v-row>
              <!--AS番号-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="AS番号"
                    :value="cloudVnGcpDetail.cloudVnConnectAct.asNumber"
                  />
                </v-col>
              </v-row>
              <!--Maximum Prefix-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Maximum Prefix"
                    :value="
                      $filter.emptyTo(
                        cloudVnGcpDetail.cloudVnConnectAct.maximumPrefix,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Act） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Act)</h3>
                </v-col>
              </v-row>
              <!--WANアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="
                      $filter.emptyTo(
                        cloudVnGcpDetail.cloudVnConnectAct.wanAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="
                      $filter.emptyTo(
                        cloudVnGcpDetail.cloudVnConnectAct.peerIpAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        cloudVnGcpDetail.cloudVnConnectAct.localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        cloudVnGcpDetail.cloudVnConnectAct.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Sby） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Sby)</h3>
                </v-col>
              </v-row>
              <template v-if="cloudVnGcpDetail.cloudVnConnectSby">
                <!--WANアドレス（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="WANアドレス"
                      :value="
                        $filter.emptyTo(
                          cloudVnGcpDetail.cloudVnConnectSby.wanAddress,
                          '-'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--ピアIPアドレス（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="ピアIPアドレス"
                      :value="
                        $filter.emptyTo(
                          cloudVnGcpDetail.cloudVnConnectSby.peerIpAddress,
                          '-'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--Local Preference（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="Local Preference"
                      :value="
                        $filter.enumTo(
                          cloudVnGcpDetail.cloudVnConnectSby.localPreference,
                          'localPreference'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <!--MED（Sby）-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="MED"
                      :value="
                        $filter.enumTo(
                          cloudVnGcpDetail.cloudVnConnectSby.med,
                          'med'
                        )
                      "
                    />
                  </v-col>
                </v-row>
              </template>
              <div class="ml-3 mb-3" v-else><span>-</span></div>

              <template
                v-if="cloudVnGcpDetail.cloudVnConnectCommon.routeAggregation"
              >
                <!-- カスタム経路集約情報 -->
                <v-row class="mt-2">
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="経路集約"
                      :value="
                        cloudVnGcpDetail.cloudVnConnectCommon.routeAggregation
                      "
                    />
                  </v-col>
                </v-row>

                <!--注意文言 : 追加確認画面又は変更確認画面のみ表示-->
                <template
                  v-if="
                    cloudVnGcpDetail.cloudVnConnectCommon.routeAggregation ===
                    'OFF'
                  "
                >
                  <v-row v-if="displayType === 'A' || displayType === 'M'">
                    <v-col>
                      <app-label-group
                        label="WVS2で学習している経路をすべて広報いたします。クラウド側の受信経路上限数を超過している場合は接続ができません。"
                      />
                    </v-col>
                  </v-row>
                </template>

                <!--経路集約アドレス-->
                <v-row v-else>
                  <v-col>
                    <app-label-group label="経路集約アドレス">
                      <template #value>
                        <template
                          v-if="
                            cloudVnGcpDetail.cloudVnConnectCommon
                              .routeAggregation === 'CUSTOM'
                          "
                        >
                          <div class="d-flex flex-wrap">
                            <span
                              class="ml-3"
                              v-for="(
                                ip, index
                              ) in sortedRouteAggregationAddressList"
                              :key="index"
                            >
                              {{ ip }}
                            </span>
                          </div>
                        </template>
                        <template
                          v-else-if="
                            cloudVnGcpDetail.cloudVnConnectCommon
                              .routeAggregation === 'ON'
                          "
                        >
                          <span class="ml-3">0.0.0.0/0</span>
                        </template>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
              </template>

              <!--備考-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="備考"
                    :value="
                      $filter.emptyTo(
                        cloudVnGcpDetail.cloudVnConnectCommon.description,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <template v-if="displayType === 'A'">
                <div class="font-weight-bold mt-5">
                  VNコネクトを追加する前に、以下確認をしてください。
                </div>
                <v-sheet border rounded class="pa-2">
                  <v-checkbox
                    v-model="checkedServicekey"
                    label="一度使用したことのあるサービスキーを入力していないこと"
                    hide-details
                  />
                  <v-checkbox
                    v-model="checkedNoModified"
                    label="VNコネクト作成中はGoogle Cloudの設定変更は実施しないこと"
                    hide-details
                  />
                </v-sheet>
              </template>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="ok"
              variant="flat"
              color="primary"
              :disabled="
                displayType === 'A'
                  ? !checkedServicekey || !checkedNoModified
                  : false
              "
              >はい</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CloudVnGcpDetail } from "@/apis/CloudVnGcpApi";

export default defineComponent({
  name: "MultiCloudGcpVnConnectionConfirm",
  props: {
    cloudVnGcpDetail: {
      type: Object as PropType<CloudVnGcpDetail>,
      required: true,
    },
    /** 画面表示モード：
     * A - 追加確認
     * M - 編集確認
     * D - 削除確認
     */
    displayType: {
      type: String as PropType<"A" | "M" | "D">,
      required: true,
    },
  },
  computed: {
    confirmMessage(): string {
      switch (this.displayType) {
        case "A":
          return "こちらの内容でクラウド接続向けVN回線を追加します。よろしいですか？";
        case "M":
          return "こちらの内容でクラウド接続向けVN回線を変更します。よろしいですか？";
        case "D":
          return "こちらの内容でクラウド接続向けVN回線を削除します。よろしいですか？";
        default:
          throw new Error("wrong displayType!");
      }
    },
    /**
     * 経路集約アドレスリストを数値順（IPアドレス順）で昇順ソートして返す
     * 削除確認画面（displayType === "D"）の場合のみソートを適用
     * @returns ソート済みの経路集約アドレスリスト
     */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.cloudVnGcpDetail?.cloudVnConnectCommon
          ?.routeAggregationAddressList;
      if (this.displayType === "D" && Array.isArray(list)) {
        return list.sortIpAddress();
      }
      return Array.isArray(list) ? list : [];
    },
  },
  data() {
    return {
      checkedServicekey: false,
      checkedNoModified: false,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-checkbox .v-selection-control) {
  min-height: auto;
}
</style>
